module.exports = __webpack_public_path__ + "img/ganttChart.34673037.png";